import React from "react";
import { Link } from "react-router-dom";
import { FRESHDESK_TICKET_STATUS_TO_TRANSLATION_KEY } from "./constants";
import { dateTimeColumnDef } from "./dateTimeColumnDef";
import { FRESHDESK_SUPPORT_TICKET_PAGE } from "../api/freshdesk-api-config";
import { Button } from "@mui/material";

export const supportTicketNumber = (t, width = 80) => {
  return {
    field: "id",
    headerName: `${t("supportTicketsDataGrid.headers.ticketNumber")}`,
    width: width,
    align: "left",
    headerAlign: "left",
  };
};

export const supportTicketParcelTrackingCode = (t, width = 200) => {
  return {
    field: "parcelNumber",
    headerName: `${t("supportTicketsDataGrid.headers.parcelTrackingCode")}`,
    width: width,
    align: "left",
    headerAlign: "left",
    valueGetter: (value, row) => row.custom_fields?.cf_parcel_number,
    renderCell: (params) => {
      const value = params.row.custom_fields?.cf_parcel_number;
      return (
        <Link
          to={`/orders/${value}/`}
          className={"text-black"}
          target="_blank"
          rel="noopener noreferrer"
        >
          {value}
        </Link>
      );
    },
  };
};

export const supportTicketStatus = (t, width = 160) => {
  return {
    field: "status",
    headerName: `${t("supportTicketsDataGrid.headers.status")}`,
    width: width,
    align: "left",
    headerAlign: "left",
    valueGetter: (value) => {
      const key = FRESHDESK_TICKET_STATUS_TO_TRANSLATION_KEY[value];
      return key ? t(key) : "";
    },
  };
};

export const supportTicketIssue = (t, width = 160) => {
  return {
    field: "type",
    headerName: `${t("supportTicketsDataGrid.headers.issue")}`,
    width: width,
    align: "left",
    headerAlign: "left",
  };
};

export const supportTicketCreatedAt = (t, width = 200) => {
  return {
    field: "created_at",
    headerName: `${t("supportTicketsDataGrid.headers.created")}`,
    width: width,
    align: "left",
    headerAlign: "left",
    ...dateTimeColumnDef,
  };
};

export const supportTicketOpenInfoButton = (t, width = 100) => {
  return {
    field: "link",
    headerName: "",
    width: width,
    align: "left",
    headerAlign: "left",
    ...dateTimeColumnDef,
    renderCell: (params) => {
      const link = FRESHDESK_SUPPORT_TICKET_PAGE(params.row.id);
      return (
        <Button variant={"contained"} color="secondary" target="_blank" href={link}>
          {t("supportTicketsDataGrid.actions.openSupportTicket")}
        </Button>
      );
    },
  };
};
